import React, {Component} from 'react';
import {Button, Col, Input, Label, Row} from "reactstrap";
import {
	deepCopyObject,
	filterServices,
	hasUserRight,
	showAxiosError,
	xsltEnumToInt,
	xsltTypeList,
	xsltTypeMap
} from "../../helper/helper";
import {request} from "../../helper/APIUtils";
import SweetAlert from 'react-bootstrap-sweetalert';
import IbanField from "./components/IbanField";
import ImageField from "./components/ImageField";
import XsltCreateModal from "./components/XsltCreateModal";
import NavBarKS from "../../components/NavBarKS";
import SquareButtonX from "../../components/SquareButtonX";
import Select from "../../local_node_modules/react-select";
import {UserRightsEnum} from "../../helper/enums";
import {VirtualHost} from "../../constants";

class XsltDesigner extends Component {
	constructor(props) {
		super(props);
		this.state = {
			alert: null,
			url: null,
			mediaModal: false,
			xmlTemplate: null,
			xsltTemplate: null,
			xsltTypeMap: xsltTypeMap,
			serviceList: [],
			xmlUrl: null,
			xsltUrl: null,
			isHalXml: false,
			type: 2,
			typeList: [],
			loading: false,
			isOpen: false,
			modelXslt: undefined,
			attributes: {
				notes: [
					{
						note: ""
					}
				],
				ibanRows: [
					{
						branch: "",
						iban: ""
					}
				],
				logoImage: {
					file: null,
					fileName: "",
					mimeType: "",
					width: 100,
					height: 100
				},
				signatureImage: {
					file: null,
					fileName: "",
					mimeType: "",
					width: 100,
					height: 100
				},
				isShowKdvTaxableAmount: false,
				eTrade:false,
				isHalXml: false,
				isShowExchangeRate: false
			},
			xslt: null,
			eTrade:false,
			isShowKdvTaxableAmount: false,
			isShowExchangeRate: false
		};
		this.fetchPreviewFiles = this.fetchPreviewFiles.bind(this);
		this.toggleModal = this.toggleModal.bind(this);
		this.handleCreate = this.handleCreate.bind(this);
		this.setMediaViewer = this.setMediaViewer.bind(this);
		this.setIban = this.setIban.bind(this);
		this.setLogoImage = this.setLogoImage.bind(this);
		this.setSignatureImage = this.setSignatureImage.bind(this);
		this.updateFrame = this.updateFrame.bind(this);
		this.noteHtml = this.noteHtml.bind(this);
		this.addRow = this.addRow.bind(this);
		this.onChangeField = this.onChangeField.bind(this);
		this.goToListPage = this.goToListPage.bind(this);
		this.onChangeShowKdvTaxableAmount = this.onChangeShowKdvTaxableAmount.bind(this);
		this.onChangeETrade = this.onChangeETrade.bind(this);
		this.onChangeIsHalXml = this.onChangeIsHalXml.bind(this);
		this.onChangeShowExchangeRate = this.onChangeShowExchangeRate.bind(this);
	}

	componentDidMount() {
		this.setState({typeList: xsltTypeList()}, () => this.fetchPreviewFiles());
		if (this.props.location && this.props.location.selectedXslt) {
			let selectedXslt = deepCopyObject(this.props.location.selectedXslt);
			let attributes = JSON.parse(selectedXslt.attributes);
			if (attributes && attributes.isShowKdvTaxableAmount === undefined) {
				attributes.isShowKdvTaxableAmount = false;
			}
			if (attributes && attributes.eTrade === undefined) {
				attributes.eTrade = false;
			}
			if (attributes && attributes.isHalXml === undefined) {
				attributes.isHalXml = false;
			}
			if (attributes && attributes.isShowExchangeRate === undefined) {
				attributes.isShowExchangeRate = false;
			}

			this.setState({
				type: xsltEnumToInt(selectedXslt.xsltType),
				xslt: selectedXslt,
				attributes: attributes,
				eTrade: attributes.eTrade,
				isHalXml: attributes.isHalXml,
				isShowKdvTaxableAmount: attributes.isShowKdvTaxableAmount
			}, () => this.fetchPreviewFiles());
		}
		if (this.props.location && this.props.location.serviceList) {
			let serviceList = deepCopyObject(this.props.location.serviceList);
			this.setState({serviceList: serviceList});
		}
		if (this.props.location && this.props.location.type) {
			this.setState({type: this.props.location.type});
		}
		if (this.props.location && this.props.location.serviceList && this.props.location.mode === 'create' && !this.props.location.type) {
			let type = this.props.location.serviceList[0];
			this.setState({type});
		}


	}

	setMediaViewer() {
		this.setState({url: null, mediaModal: false});
	}

	handleCreate() {
		let self = this;
		if ((this.state.type === 1 || this.state.type === 7 || this.state.type === 8) && this.state.attributes.signatureImage.file === null) {
			showAxiosError({Error: "Lütfen İmza Logosu Yükleyiniz!"});
		}
		else {
			this.updateFrame().then(() => {
				let modelXslt = {
					id: this.state.xslt ? this.state.xslt.recordId : null,
					content: this.state.currentXslt,
					filename: this.state.xslt ? this.state.xslt.xsltFilename : null,
					type: this.state.type,
					isDefault: (!this.props.currentUser.isAdminUser && this.props.currentUser.hasXslt) ? (this.state.xslt ? this.state.xslt.isDefaultUserXslt : 0  ) : (this.state.xslt ? this.state.xslt.isDefault : 0) ,
					attributes: this.state.attributes,
				}
				self.setState({modelXslt}, () => this.toggleModal());
			})
		}
	}

	openDeleteConfirmModal(row) {
		this.setState({
			alert: (
				<SweetAlert showCancel warning
							confirmBtnText="Evet"
							cancelBtnText="Hayır"
							confirmBtnBsStyle="danger"
							cancelBtnBsStyle="default"
							title="Emin Misiniz?"
							onConfirm={() => this.handleDelete(row)}
							onCancel={() => this.setState({alert: null})}
				>
					{"XSLT silinecek."}
				</SweetAlert>
			)
		})
	}

	async fetchPreviewFiles() {
		let self = this;
		let formData = new FormData();
		formData.append("type", this.state.type);
		formData.append("isHalXml", this.state.isHalXml);
		formData.append("isShowKdvTaxableAmount", (this.state.isShowKdvTaxableAmount || (this.state.attributes && this.state.attributes.isShowKdvTaxableAmount)));
		formData.append("isShowExchangeRate", (this.state.isShowExchangeRate || (this.state.attributes && this.state.attributes.isShowExchangeRate)));
		let params = {
			url: `/xslt/fetchPreviewFiles`,
			method: "post",
			data: formData
		};
		self.setState({loading: true});
		request(params)
			.then(function (response) {
				let xml = response.data.xml
				let xslt = response.data.xslt
				let xsltUrl = URL.createObjectURL(new Blob([xslt], {type: 'application/xslt+xml'}));
				let tempXml = xml.replace(/XSLT_REF/, xsltUrl);
				let xmlUrl = URL.createObjectURL(new Blob([tempXml], {type: 'application/xml'}));
				self.setState({
					xmlTemplate: xml,
					xsltTemplate: xslt,
					currentXslt: xslt,
					xmlUrl: xmlUrl,
					xsltUrl: xsltUrl,
					loading: false,
				}, () => self.updateFrame());

			}).catch(function (error) {
			self.setState({loading: false});
			showAxiosError(error);
		});
	}

	setLogoImage(logoImage) {
		let attributes = this.state.attributes;
		attributes.logoImage = logoImage;
		this.setState({attributes});
	}

	setSignatureImage(signatureImage) {
		let attributes = this.state.attributes;
		attributes.signatureImage = signatureImage;
		this.setState({attributes});
	}

	setIban(ibanRows) {
		let attributes = this.state.attributes;
		attributes.ibanRows = ibanRows;
		this.setState({attributes});
	}

	noteHtml() {
		let {notes} = this.state.attributes;
		let htmlNotes = notes.map(row => {
			return (((this.state.type === 6) ? '<b>Not: </b>\n' : '<b>&#160;&#160;&#160;&#160;&#160; Not: </b>\n') +
				'\t\t\t\t\t\t\t\t<xsl:text>' + row.note + '</xsl:text>\n' +
				'\t\t\t\t\t\t\t\t<br/>')
		});
		return htmlNotes.join("\n");
	}

	ibanHtml() {
		let {ibanRows} = this.state.attributes;
		let htmlStart = `<table border="1" cellpadding="1" cellspacing="1" style="width: 800px;"> 
					<tbody>`

		let htmlEnd = `</tbody> 
				</table>`

		let htmlRowsArray = ibanRows.map(row => {
			if (!!row.branch.trim() && !!row.iban.trim()) {
				return (
					`<tr>
					<td style="width: 239px;">
						<span style="color: rgb(68, 68, 68); font-family: verdana, geneva, sans-serif; font-size: 10px; line-height: 20.82px; text-align: center;">&#xa0; &#xa0;&#xa0;${row.branch}</span>
					</td>
					<td style="width: 450px;">
						<span style="color: rgb(68, 68, 68); font-family: verdana, geneva, sans-serif; font-size: 10px; line-height: 20.82px; text-align: center; background-color: rgb(255, 255, 255);">&#xa0; &#xa0;&#xa0;IBAN:&#xa0;${row.iban}</span>
					</td>
				</tr>`)
			} else {
				return "";
			}
		});

		if (htmlRowsArray.length > 0) {
			return htmlStart + htmlRowsArray.join("\n") + htmlEnd;
		} else {
			return "";
		}
	}

	orderRefund(){
		return '<br/>\n' +
			'    <table style="width:100%; font-size: 13px;" >\n' +
			'        <tbody>\n' +
			'            <table style="width:100%;">\n' +
			'                <tbody>\n' +
			'                    <tr bgcolor="#E0E0E0">\n' +
			'                        <th style="border-style: solid; border-width: 1px; height: 27px; font-weight: bolder;">MALI İADE EDENİN</th>\n' +
			'                    </tr>\n' +
			'                </tbody>\n' +
			'            </table>\n' +
			'\n' +
			'            <table style="width:100%;">\n' +
			'                <tbody>\n' +
			'                    <tr>\n' +
			'                        <th style="width:70px; height: 27px; font-weight: bolder; border-style: solid; border-width:0 0 0 1px;  background-color:#E0E0E0">ADI</th>\n' +
			'                        <th style="height: 27px; font-weight: bolder; border-style: solid; border-width:0 0 0 1px;"></th>\n' +
			'                        <th style="width:70px; height: 27px; font-weight: border-style: solid; bolder; border-style: solid; border-width:0 0 0 1px; background-color:#E0E0E0">SOYADI</th>\n' +
			'                        <th style="height: 27px; font-weight: bolder; border-style: solid; border-width:0 0 0 1px;"></th>\n' +
			'                        <th style="width:70px; height: 27px; font-weight: bolder; border-style: solid; border-width:0 0 0 1px; background-color:#E0E0E0">İMZASI</th>\n' +
			'                        <th style="height: 27px; font-weight: bolder; border-style: solid; border-width:0 1px;"></th>\n' +
			'                    </tr> \n' +
			'                </tbody>\n' +
			'            </table>\n' +
			'\n' +
			'            <table style="width:100%;">\n' +
			'                <tbody>\n' +
			'                     <tr>\n' +
			'                        <th style="width:70px; height: 27px; font-weight: bolder; border-style: solid; border-width:1px 0 1px 1px; background-color:#E0E0E0">ADRES</th>\n' +
			'                        <th style="border-style: solid; border-width: 1px; height: 27px;"></th>\n' +
			'                    </tr>\n' +
			'                </tbody>\n' +
			'            </table>\n' +
			'\n' +
			'            <br/>\n' +
			'            \n' +
			'            <table style="width:100%;">\n' +
			'                <tbody>\n' +
			'                     <tr bgcolor="#E0E0E0">\n' +
			'                        <th style="border-style: solid; border-width: 1px; height: 27px; font-weight: bolder;">İADE EDİLEN MALIN</th> \n' +
			'                    </tr>\n' +
			'                </tbody>\n' +
			'            </table>\n' +
			'\n' +
			'            <table style="width:100%;">\n' +
			'                <tbody>\n' +
			'                     <tr>\n' +
			'                        <th style="height: 27px; font-weight: bolder; border-style: solid; border-width:0 0 0 1px; background-color:#E0E0E0">Cinsi</th>\n' +
			'                        <th style="height: 27px; font-weight: bolder; border-style: solid; border-width:0 0 0 1px; background-color:#E0E0E0">Miktar</th>\n' +
			'                        <th style="height: 27px; font-weight: bolder; border-style: solid; border-width:0 0 0 1px; background-color:#E0E0E0">Birim Fiyatı</th>\n' +
			'                        <th style="height: 27px; font-weight: bolder; border-style: solid; border-width:0 0 0 1px; background-color:#E0E0E0">Tutarı</th>\n' +
			'                        <th style="height: 27px; font-weight: bolder; border-style: solid; border-width:0 1px; background-color:#E0E0E0">İade Nedeni</th> \n' +
			'                    </tr>\n' +
			'                    <tr>\n' +
			'                        <td style="height: 27px; font-weight: bolder; border-style: solid; border-width:1px 0 1px 1px; border-color: #1b1d1f"></td>\n' +
			'                        <td style="height: 27px; font-weight: bolder; border-style: solid; border-width:1px 0 1px 1px; border-color: #1b1d1f"></td>\n' +
			'                        <td style="height: 27px; font-weight: bolder; border-style: solid; border-width:1px 0 1px 1px; border-color: #1b1d1f"></td>\n' +
			'                        <td style="height: 27px; font-weight: bolder; border-style: solid; border-width:1px 0 1px 1px; border-color: #1b1d1f"></td>\n' +
			'                        <td style="height: 27px; font-weight: bolder; border-style: solid; border-width:1px; border-color: #1b1d1f"></td>\n' +
			'                    </tr>\n' +
			'                </tbody>\n' +
			'            </table>\n' +
			'        </tbody>\n' +
			'    </table>'
	}

	async updateFrame() {
		this.setState({loading: true})
		let {xmlTemplate, xsltTemplate} = this.state;
		let {ibanRows, logoImage, signatureImage, notes} = this.state.attributes;
		if (xmlTemplate && xsltTemplate) {
			if (ibanRows.length > 0 && ibanRows[0].iban && ibanRows[0].branch) //to prevent redundant replacement for the initial state
				xsltTemplate = xsltTemplate.replace(/<!-- IBAN_REF -->/, this.ibanHtml())

			if (notes.length > 0 && notes[0].note)
				xsltTemplate = xsltTemplate.replace(/<!-- NOTE_REF -->/, this.noteHtml());

			if (logoImage.file && (logoImage.width > 0 || logoImage.height > 0)) { //to prevent redundant replacement
				xsltTemplate = xsltTemplate.replace(/<!-- LOGO_REF -->/, this.imageHtml("logoImage"))
			}

			if (signatureImage.file && (signatureImage.width > 0 || signatureImage.height > 0)) { //to prevent redundant replacement
				xsltTemplate = xsltTemplate.replace(/<!-- SIGN_REF -->/, this.imageHtml("signatureImage"))
			}

			if(this.state.eTrade){
				xsltTemplate = xsltTemplate.replace(/<!-- ORDER-REFUND -->/,this.orderRefund())
			}

			let xsltUrl = URL.createObjectURL(new Blob([xsltTemplate], {type: 'application/xslt+xml'}));

			xmlTemplate = xmlTemplate.replace(/XSLT_REF/, xsltUrl);
			let xmlUrl = URL.createObjectURL(new Blob([xmlTemplate], {type: 'application/xml'}));

			this.setState({
				currentXslt: xsltTemplate,
				xmlUrl: xmlUrl,
				xsltUrl: xsltUrl,
				loading: false,
			});
		}
	}

	toggleModal() {
		this.setState({isOpen: !this.state.isOpen});
	}

	addRow() {
		let {notes} = this.state.attributes;
		notes.push({note: ""});
		this.setState({notes});
	}

	onChangeField(e, i) {
		if (!e) return;

		let target = e.target;
		let {notes} = this.state.attributes;
		notes[i]["note"] = target.value;
		this.setState({notes});
	}

	removeRow(rowIndex) {
		let {notes} = this.state.attributes;
		notes.splice(rowIndex, 1);
		this.setState({notes});
	}

	goToListPage() {
		this.props.history.push( this.props.location.customerId === 0 || this.props.location.customerId === null ? '/xsltYonetimi' : `/xsltYonetimi/${this.props.location.customerId}`);
	}

	onChangeShowKdvTaxableAmount(e) {
		let attributes = this.state.attributes;
		attributes.isShowKdvTaxableAmount = e.target.checked;
		this.setState({attributes, isShowKdvTaxableAmount: e.target.checked}, () => this.fetchPreviewFiles());
	}

	onChangeETrade(e){
		let attributes = this.state.attributes;
		attributes.eTrade = e.target.checked;
		this.setState({attributes, eTrade: e.target.checked}, () => this.fetchPreviewFiles());
	}

	onChangeIsHalXml(e){
		let attributes = this.state.attributes;
		attributes.isHalXml = e.target.checked;
		this.setState({attributes, isHalXml: e.target.checked}, () => this.fetchPreviewFiles());
	}

	onChangeShowExchangeRate(e) {
		let attributes = this.state.attributes;
		attributes.isShowExchangeRate = e.target.checked;
		this.setState({attributes, isShowExchangeRate: e.target.checked}, () => this.fetchPreviewFiles());
	}

	render() {
		let allServices = [];
		const source = VirtualHost.conf.resourcePrefix;

		allServices = filterServices(this.state.xsltTypeMap, this.state.serviceList);
		return (
			<div className="row baseBackground">
				<NavBarKS offsetWidth={this.props.offsetWidth} innerWidth={window.innerWidth}>
					<SquareButtonX
							position="leftSide" img="" onClick={() => this.props.history.push({pathname: this.props.location.customerId === 0 || this.props.location.customerId === null ? '/xsltYonetimi' : `/xsltYonetimi/${this.props.location.customerId}`})} label="Geri"/>
				</NavBarKS>
				{this.state.alert}


				<div className="satirBasi" style={{display: 'block', padding: '10px'}}>
					<div style={{padding: '10px 0 10px 20px', background: 'white', borderRadius: '15px', margin: '0 0 20px 0'}}>
						<h4>{this.state.xslt && this.state.xslt.recordId ? 'XSLT Düzenle' : 'XSLT Oluştur'}</h4>
					</div>

					<div className="row col pt-3 pb-3">
						<div className="col-2">
							<label style={{fontWeight: 'bold', margin: 0}}>XSLT Türü:</label>
						</div>

						<div className="col-10">
							<Select
								clearable={false} searchable={false}
								value={this.state.type}
								onChange={e => {
									this.setState({type: e.value}, () => this.fetchPreviewFiles())
								}}
								options={allServices && Array.isArray(allServices) && allServices.map((type) => ({value: type.value, label: type.label}))}
							/>
						</div>
					</div>

					{this.state.loading ? "Loading.." :
						<Row style={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap', padding: '0 15px'}}>

							<Col xs='12' lg='5' style={{display: 'block', padding: 0}}>

								{/*sabit not bolumu*/}
								<div style={{
									display: 'block',
									padding: '20px 5px 20px 10px',
									border: 'solid 1px #cacaca',
									borderRadius: '5px',
									width: '100%',
									margin: '5px 0'
								}}>
									<div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
										<div style={{padding: '5px'}}>
											<h6 style={{margin: 0}}>
												Notlar
											</h6>
										</div>

										<div>
											<Button className="TekBtn ekle" onClick={this.addRow}>Ekle</Button>
										</div>
									</div>

									<div>
										{this.state.attributes.notes && this.state.attributes.notes.length === 0 &&
										<div style={{display: 'flex', flexDirection: 'row'}}>
											<h2>
												Not eklenmedi.
											</h2>
										</div>}

										{this.state.attributes.notes && this.state.attributes.notes.length !== 0 && this.state.attributes.notes.map((row, i) =>
											<div key={i} style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
												<div style={{width: '20%'}}>
													<Label style={{margin: 0, fontWeight: 'bold'}}>Sabit Not</Label>
												</div>

												<div style={{width: '70%'}}>
													<Input type="text" name="notes" value={row.note}
														   onChange={e => this.onChangeField(e, i)}/>
												</div>

												<div style={{width: '10%', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
													<button style={{marginBottom: '1px', padding: 0}} className="Btn"
															onClick={() => this.removeRow(i)}>
														<i className="fa fa-remove"/>
													</button>
												</div>
											</div>)
										}
									</div>
								</div>

								<IbanField setIban={this.setIban}
										   rows={this.state.attributes.ibanRows && this.state.attributes.ibanRows}/>

								<ImageField setImage={this.setLogoImage}
											image={this.state.attributes.logoImage && this.state.attributes.logoImage}
											logoTitle={"Firma Logosu"}/>

								<ImageField setImage={this.setSignatureImage}
											image={this.state.attributes.signatureImage && this.state.attributes.signatureImage}
											logoTitle={"İmza Logosu"}/>
							</Col>

							<Col xs='12' lg='7' style={{display: 'block', padding: '0'}}>

								{(this.state.type === 1 || this.state.type === 2) &&
									<div className="row mx-2">
										<div className="col-md-6 d-flex align-items-center">
											<div>
												<Label className="m-0" style={{fontWeight: "bold"}}>Hal tipi fatura ile
													göster</Label>
											</div>
											<div className="pt-1 my-0 ml-auto">
												<input type="checkbox" style={{width: 16, height: 16}}
													   checked={this.state.isHalXml || (this.state.attributes && this.state.attributes.isHalXml)}
													   onChange={(e) => this.onChangeIsHalXml(e)}/>
											</div>
										</div>

										<div className="col-md-6 d-flex align-items-center">
											<div>
												<Label className="m-0" style={{fontWeight: "bold"}}>E-Ticaret fatura ile
													göster</Label>
											</div>
											<div className="pt-1 my-0 ml-auto">
												<input type="checkbox" style={{width: 16, height: 16}}
													   checked={this.state.eTrade || (this.state.attributes && this.state.attributes.eTrade)}
													   onChange={(e) => this.onChangeETrade(e)}/>
											</div>
										</div>

										<div className="col-md-6 d-flex align-items-center">
											<div>
												<Label className="m-0" style={{fontWeight: "bold"}}>KDV Matrahları ayrı
													gösterilsin</Label>
											</div>
											<div className="pt-1 my-0 ml-auto">
												<input type="checkbox" style={{width: 16, height: 16}}
													   checked={this.state.isShowKdvTaxableAmount || (this.state.attributes && this.state.attributes.isShowKdvTaxableAmount)}
													   onChange={(e) => this.onChangeShowKdvTaxableAmount(e)}/>
											</div>
										</div>
										<div className="col-md-6 d-flex align-items-center">
											<div>
												<Label className="m-0" style={{fontWeight: "bold"}}>Döviz Kuru faturada
													gösterilsin</Label>
											</div>
											<div className="pt-1 my-0 ml-auto">
												<input type="checkbox" style={{width: 16, height: 16}}
													   checked={this.state.isShowExchangeRate || (this.state.attributes && this.state.attributes.isShowExchangeRate)}
													   onChange={e => this.onChangeShowExchangeRate(e)}/>
											</div>
										</div>
									</div>
								}

								{(!this.state.loading && this.state.xmlUrl) &&
								<div style={{width: '100%', padding: '2px 15px 2px 15px'}}>
									{this.state.xmlUrl &&
									<iframe src={this.state.xmlUrl} style={{width: '100%', minHeight: '588px'}}/>}

									{!this.state.xmlUrl && "Yükleniyor..."}
								</div>
								}
							</Col>

							<Col xs='12' style={{textAlign: 'end'}}>
								<Button className="TekBtn onizle"
										style={{
											padding: '11px 68px 11px 32px',
											marginLeft: '-18px',
											marginTop: '50px',
											background: '#70a0bf',
										}}
										onClick={this.updateFrame}
										disabled={!hasUserRight(UserRightsEnum.settings.xslt.view,this.props.currentUser)}
								>

									ÖNİZLE
								</Button>

								<Button className="TekBtn kaydet"
										style={{
											padding: '11px 68px 11px 32px',
											marginLeft: '18px',
											marginTop: '50px'
										}}
										onClick={this.handleCreate}
										disabled={this.state.loading || ( this.state.xslt && (this.state.xslt.recordId !== null) ? !hasUserRight(UserRightsEnum.settings.xslt.update,this.props.currentUser) : !hasUserRight(UserRightsEnum.settings.xslt.create,this.props.currentUser))}>
									{this.state.xslt && (this.state.xslt.recordId !== null) ? 'GÜNCELLE' : 'KAYDET'}

								</Button>
							</Col>
						</Row>
					}
				</div>
				{this.state.isOpen &&
				<XsltCreateModal modal={this.state.isOpen}
								 listener={this.toggleModal}
								 xslt={this.state.modelXslt}
								 goToListPage={this.goToListPage}
								 serviceList={this.state.serviceList}
								 currentUser={this.props.currentUser}
								 customerId={this.props.location.customerId}
				/>
				}
			</div>
		);
	}


	imageHtml(imageName) {
		let {width, height, file, mimeType} = this.state.attributes[imageName]

		let widthStr = width && Number.isInteger(width) && width > 0 ? `width="${width}"` : "";
		let heightStr = height && Number.isInteger(height) && height > 0 ? `height="${height}"` : "";
		let logoHtml = (
			`<img src="data:${mimeType};base64, ${file}" alt="company_logo" ${widthStr} ${heightStr}/>`
		)
		return logoHtml;
	}
}

export default XsltDesigner;
